<template>
  <tr>
    <td>{{ user.Profile.Name }}</td>
    <td>{{ item.Category }}</td>
    <td>{{ item | periodFormat }}</td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{  }}</td> -->
    <td v-show="!isMobile">{{ agent.Profile.Name }}</td>
    <td v-show="!isMobile">{{ item.Status }}</td>
    <!-- 以上手機版不顯示 -->
    <td>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>

      <v-chip
        v-if="isSignEnabled"
        color="red"
        small
      >待審核</v-chip>
      <v-chip
        v-else-if="isSubmitEnabled"
        color="red"
        small
      >待確認</v-chip>
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    agent() {
      return this.users.find(o => o.ID == this.item.AgentID);
    },
    user() {
      return (
        this.users.find(o => o.ID == this.item.CreatedBy) || { Profile: {} }
      );
    },
    isSubmitEnabled() {
      return (
        this.item.Status == "代理人確認中" && this.me.ID == this.item.AgentID
      );
    },
    isSignEnabled() {
      return (
        (this.item.Status == "主管確認中" &&
          this.myLevel == 10 &&
          this.item.DepartmentID == this.myDepartment.ID) ||
        (this.item.Status == "代理人確認中" &&
          this.myLevel == 10 &&
          this.item.DepartmentID == this.myDepartment.ID &&
          this.item.AgentID == this.me.ID) ||
        (this.item.Status == "人資審核中" &&
          this.myLevel == 100)
      );
    },
    ...mapGetters(["users", "me", "myLevel", "myDepartment"])
  },
  methods: {
    view() {
      let id = this.item.ID;
      this.$store.state.UI.dialog.leaveFormDetail.id = id;
      this.$store.state.UI.dialog.leaveFormDetail.isShow = true;
    }
  }
};
</script>